<template>
  <div>
    <div
      v-for="(condition, idx) in conditions"
      :key="condition.id"
      :class="{'just-moved': feedback.recentlyMovedCondition === condition}"
      class="condition"
    >
      <div class="body">
        <div v-if="conditions.length > 1 || condition.type!=''" class="float-right">
          <a
            v-if="groupCount > 1 && !feedback.movingCondition"
            :class="defaultButtonClasses.concat(['btn-secondary', 'move-condition'])"
            href="#"
            @click.prevent="feedback.startMovingCondition(condition)"
          >
            <span class="fa fa-arrows-alt" /> Move Condition
          </a>
          <a
            v-else-if="feedback.movingCondition === condition"
            :class="defaultButtonClasses.concat(['btn-secondary', 'cancel-move'])"
            href="#"
            @click.prevent="feedback.cancelMovingCondition()"
          >
            <span class="fa fa-times" /> Cancel Move
          </a>
          <a
            :class="defaultButtonClasses.concat(['btn-danger'])"
            href="#"
            @click.prevent="removeItem(conditions, idx)"
          >
            <span class="fa fa-trash"/>
            <span class="sr-only">Delete Condition</span>
          </a>
        </div>
        <div v-if="isConditionInvalid(condition)" class="alert alert-danger condition-error">
          Select a condition type for this row, or delete it.
        </div>
        <div :class="{'has-error': isConditionInvalid(condition)}">
        <select v-model="condition.type" class="form-control" @change="feedback.updateConditionProps(condition)">
          <option value="">
            Select condition
          </option>
          <option v-for="(label, value) in config.conditionTypes" :value="value">
            {{ label }}
          </option>
        </select>
        </div>
        <component :is="condition.type" v-bind.sync="condition" :config="config" />
      </div>
      <div v-if="idx < conditions.length - 1" class="separator">
        {{ separator }}
      </div>
    </div>
    <div class="condition-footer">
      <template v-if="conditions.length === 1">
        <a
          :class="defaultButtonClasses.concat(['btn-primary', 'add-condition', 'add-and-condition'])"
          href="#"
          @click.prevent="feedback.addConditionToGroup(group, conditions.length + 1)"
        >
          <span class="fa fa-plus" /> Add AND Condition
        </a>
        <a
          :class="defaultButtonClasses.concat(['btn-primary', 'add-condition', 'add-or-condition'])"
          href="#"
          @click.prevent="feedback.addConditionToGroup(group, 1)"
        >
          <span class="fa fa-plus" /> Add OR Condition
        </a>
      </template>
      <a
        v-else
        :class="defaultButtonClasses.concat(['btn-primary', 'add-condition'])"
        href="#"
        @click.prevent="feedback.addCondition(group, conditions.length - 1)"
      >
        <span class="fa fa-plus" /> Add Condition
      </a>
    </div>
  </div>
</template>
<script>
  // Conditions
  import Completion from './conditions/Completion.vue';
  import EventCompletionLookback from './conditions/EventCompletionLookback.vue';
  import EventComplianceLookback from './conditions/EventComplianceLookback.vue';
  import IfBlockFormField from './conditions/IfBlockFormField.vue';
  import IfFormField from './conditions/IfFormField.vue';
  import IfTeamRep from './conditions/IfTeamRep.vue';
  import IfVariable from './conditions/IfVariable.vue';
  import IfParticipantLanguage from './conditions/IfParticipantLanguage.vue';
  import IfMissingProfileFields from './conditions/IfMissingProfileFields.vue';
  import IfSourceLastDatum from './conditions/IfSourceLastDatum.vue';
  import PartnerEventCompletionLookback from './conditions/PartnerEventCompletionLookback.vue';
  import PartnerEventComplianceLookback from './conditions/PartnerEventComplianceLookback.vue';
  import SurveyLookback from './conditions/SurveyLookback.vue';
  import AdherenceCategory from './conditions/AdherenceCategory.vue';
  import AdherenceCategoryLookback from './conditions/AdherenceCategoryLookback.vue';
  import IfPhoneNumber from './conditions/IfPhoneNumber.vue';
  import IfStudyGroup from './conditions/IfStudyGroup.vue';

  export default {
    components: {
      Completion,
      EventCompletionLookback,
      EventComplianceLookback,
      IfBlockFormField,
      IfFormField,
      IfTeamRep,
      IfVariable,
      IfParticipantLanguage,
      IfMissingProfileFields,
      IfSourceLastDatum,
      PartnerEventCompletionLookback,
      PartnerEventComplianceLookback,
      SurveyLookback,
      AdherenceCategory,
      AdherenceCategoryLookback,
      IfPhoneNumber,
      IfStudyGroup,
    },
    props: {
      conditions: {
        type: Array,
        default: () => []
      },
      group: Object,
      groupCount: {
        type: Number,
        default: 1
      },
      config: Object,
      defaultButtonClasses: Array,
      separator: String,
      feedback: {
        type: Object, // should really be type: Feedback but that causes an import dependency cycle
      },
    },
    data: function () {
      return {
        // Only start showing empty-condition errors once a submission has
        // been attempted; from then on they clear live as conditions are
        // filled in, since fixing this is a single dropdown selection.
        submissionAttempted: false
      };
    },
    computed: {
      // A lone empty condition in the only group of a scenario is the
      // intentional "always run then/otherwise" shorthand, not a
      // forgotten fill-in - only that specific shape is exempt.
      isAlwaysRunCondition: function () {
        return this.groupCount === 1 && this.conditions.length === 1;
      },
    },
    methods: {
      removeItem: function (list, idx) {
        list.splice(idx, 1);
      },
      isConditionInvalid: function (condition) {
        return this.submissionAttempted && !condition.type && !this.isAlwaysRunCondition;
      },
      validate: function () {
        this.submissionAttempted = true;

        var valid = !this.conditions.some(condition => this.isConditionInvalid(condition));

        this.$children.forEach(function (component) {
          if (component.hasOwnProperty('validate')) {
            valid = component.validate() && valid;
          }
        });
        return valid;
      },
    },
  }
</script>
